export async function fetchCandidateListing(queryParams) {
  const queryString = new URLSearchParams(queryParams).toString()

  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      `${process.env.REACT_APP_API}/candidates/?${queryString}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      body: undefined,
      success: false,
      message: "Something went wrong!",
    };
  }
}

export async function fetchCandidateDetails(id, group) {
  const queryString = new URLSearchParams({"group":group}).toString()

  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      `${process.env.REACT_APP_API}/candidates/${id}/?${queryString}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          // "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      body: undefined,
      success: false,
      message: "Something went wrong!",
    };
  }
}